// services/menu.js
import axiosInstance from './axiosInstance';

const MENU_API_URL = '/menu';

const menuService = {

  /**
   * Atualiza permissão de um módulo específico
   * @param {string} idempresa - ID da empresa
   * @param {string} module - Nome do módulo
   * @param {boolean} value - Valor da permissão (true/false)
   * @returns {Promise<Object>} - Resposta da API
   */
  async updateModulePermission(idempresa, module, value) {
    try {
      const response = await axiosInstance.post(`${MENU_API_URL}/permissions/set.php`, {
        idempresa,
        module,
        value,
      });
      return response.data;
    } catch (error) {
      console.error('Error updating module permission:', error);
      throw error;
    }
  },

  /**
   * Atualiza múltiplas permissões de módulos em lote
   * @param {string} idempresa - ID da empresa
   * @param {Object} modules - Objeto com módulos e seus valores {moduleName: boolean}
   * @returns {Promise<Object>} - Resposta da API
   */
  async updateMultipleModulePermissions(idempresa, modules) {
    try {
      const response = await axiosInstance.post(`${MENU_API_URL}/permissions/set.php`, {
        idempresa,
        modules,
      });
      return response.data;
    } catch (error) {
      console.error('Error updating multiple module permissions:', error);
      throw error;
    }
  },
};

export default menuService;
